import type { PlanInterval } from "@productlane/lib/src/browser"

export type PlanGateAction = "none" | "start-trial" | "view-plans"

export function toPlanInterval(
	interval: "month" | "year" | null | undefined,
): PlanInterval {
	return interval === "year" ? "yearly" : "monthly"
}

export function getPlanGateAction({
	hasRequiredPlan,
	initialized,
	isTrial,
	hadRecentCancellation,
}: {
	hasRequiredPlan: boolean
	initialized: boolean
	isTrial: boolean
	hadRecentCancellation: boolean
}): PlanGateAction {
	if (!initialized || hasRequiredPlan) {
		return "none"
	}
	// Stripe rejects a second trial within two weeks of a cancellation, and a
	// workspace already trialing has to pick a plan instead of stacking trials.
	if (isTrial || hadRecentCancellation) {
		return "view-plans"
	}
	return "start-trial"
}
